import EventActionProto from 'core/gd-session/event-action-proto';

module.exports = class SessionMeetingNew extends EventActionProto {

    constructor(uid, data, sid, companyId, sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            meeting     : sessionEvent.data,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {

        // never initialized
        if (!gd.session.meetings) {
            // ignore
        } else {
            gd.session.meetings.add(this.data);
        }

        gd.modelBus.newUpdate('meeting', this.method, this.header.meeting.id, this.data, this.header)

        super.process();
    }
};

